import warehouseApi from '@/api/warehouse';
import optionApi from '@/api/option';

const defaultState = () => ({
	warehouseResults: [],
	warehousePagination: '',
	responSukses: {},
	konfirmResponse: {},
	warehouseArea: [],
	province: [],
	city: [],
	subdistrict: []

});

const state = defaultState();

const getters = {

};

const mutations = {

	listWarehouse(state, data) {
		state.warehouseResults = data.data.map((el) => {
			if (el.warehouse_is_active == "active") {
				el.warehouse_is_active = true
			} else {
				el.warehouse_is_active = false
			}
			return el
		});
		state.warehousePagination = data.pagination;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.konfirmResponse = {};
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	listOptionWarehouseArea(state, data) {
		state.warehouseArea = data;
	},
	listOptionProvince(state, data) {
		state.province = data;
	},
	listOptionCity(state, data) {
		state.city = data;
	},
	listOptionSubdistrict(state, data) {
		state.subdistrict = data;
	},
	clearDataWarehouse(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getWarehouse({ commit }, value) {
		warehouseApi.getDataWarehouse(value).then(({ data: { data } }) => {
			commit('listWarehouse', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listWarehouse', { data: [], pagination: {} });
		});
	},
	getWarehouseAreaOption({ commit }) {
		return new Promise((resolve) => {
			optionApi.getOptionWarehouseArea().then(({ data: { data: { results } } }) => {
				commit('listOptionWarehouseArea', results);
				resolve(results)
			}).catch(() => {
				commit('listOptionWarehouseArea', []);
				resolve([])
			});
		})
	},
	getProvinceOption({ commit }) {
		optionApi.getOptionProvince().then(({ data: { data: { results } } }) => {
			commit('listOptionProvince', results);
		}).catch(() => {
			commit('listOptionProvince', []);
		});
	},
	getCityOption({ commit }, val) {
		optionApi.getOptionCity({ province_id: val }).then(({ data: { data: { results } } }) => {
			commit('listOptionCity', results);
		}).catch(() => {
			commit('listOptionCity', []);
		});
	},
	getSubdistrictOption({ commit }, val) {
		optionApi.getOptionSubdistrict({ city_id: val }).then(({ data: { data: { results } } }) => {
			commit('listOptionSubdistrict', results);
		}).catch(() => {
			commit('listOptionSubdistrict', []);
		});
	},
	async exportWarehouse({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await warehouseApi.exportWarehouse(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data warehouse'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async add({ commit, dispatch }, value) {
		dispatch('isAttempting', null, { root: true });
		commit("konfirmasiSukses", {});
		await warehouseApi.addWarehouse(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menambah warehouse'
			}, { root: true });
		});
		dispatch('attempted', null, { root: true });
	},
	async update({ commit, dispatch }, value) {
		dispatch('isAttempting', null, { root: true });
		commit("konfirmasiSukses", {});
		await warehouseApi.updateWarehouse(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah warehouse'
			}, { root: true });
		});
		dispatch('attempted', null, { root: true });
	},
	async delete({ commit, dispatch }, value) {
		dispatch('isAttempting', null, { root: true });
		commit("konfirmasiSukses", {});
		await warehouseApi.deleteWarehouse({ id: value }).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus data warehouse'
			}, { root: true });
		});
		dispatch('attempted', null, { root: true });
	},
	async status({ commit, dispatch }, value) {
		dispatch('isAttempting', null, { root: true });
		commit("konfirmasiSukses", {});
		await warehouseApi.statusWarehouse(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah data warehouse'
			}, { root: true });
		});
		dispatch('attempted', null, { root: true });
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};